(() => {
  document.querySelectorAll('[data-cart-count]').forEach((link) => {
    const number = link.querySelector('.cart-count-number');
    if (!number) return;
    let previous = parseInt(number.textContent, 10) || 0;

    new MutationObserver(() => {
      const count = parseInt(number.textContent, 10) || 0;
      link.classList.toggle('has-items', count > 0);
      if (count > previous) {
        link.classList.remove('is-bumped');
        void link.offsetWidth;
        link.classList.add('is-bumped');
      }
      previous = count;
    }).observe(number, { childList: true, characterData: true, subtree: true });

    link.addEventListener('animationend', () => link.classList.remove('is-bumped'));
  });
})();
